import SlidingText from './SlidingText';

export default SlidingText;
